import { getAPI, postAPI, putAPI, deleteAPI } from '../..';
import config from '../../../utils/config';
import {
  GET_POLICY_DOCS_URL,
  GET_QUICKLINK_IMAGES_REVIEWS_URL,
  GET_QUICKLINK_WALLET_URL,
  GET_TRAVEL_PARTNERS_BLOCK_LIST,
  GET_TRAVEL_PARTNERS_URL,
  UPLOAD_QUICKLINK_WALLET_URL,
  ADD_NEW_TRAVEL_PARTNERS,
  EDIT_TRAVEL_PARTNERS,
  DELETE_TRAVEL_PARTNERS,
  ADD_HOTEL_DETAILS,
  EDIT_HOTEL_DETAILS,
  DELETE_HOTEL_DETAILS,
  GET_HOTEL_DETAILS,
  BULK_UPLOAD_HOTEL_DETAILS,
  UPLOAD_MENU_URL,
  DOWNLOAD_REVIEW_REPORT,
  GET_QUIZ,
  EXECUTE_COST_BENCHMARK,
  GET_COST_BENCHMARKING_DATA,
  GET_SURVEY_FORM_RESPONSES,
  GET_BENCHMARK_DATA,
  EDIT_BENCHMARK_DATA,
  EDIT_BENCHMARK,
  ADD_EVENT_SESSION,
  EDIT_EVENT_SESSION,
  GET_EVENT_SESSIONS,
  DELETE_EVENT_SESSION,
  GET_FOOD_MENU_URL,
  UPDATE_FOOD_MENU_STATUS,
  DELETE_WALLET,
  DOWNLOAD_SURVEY_REPORT,
  GET_DELETED_EVENTS,
  GET_QUOTATION_REQUESTS,
  APPROVE_QUOTATION_REQUEST,
  UPLOAD_QUOTATION,
  EDIT_QUOTATION,
  DELETE_QUOTATION,
  LIST_QUOTATIONS,
  REQUEST_EDIT_QUOTATION,
  QUOTATION_ANALYSIS,
  UPDATE_BENCHMARK_FROM_INVOICE,
} from '../../url';

import { getAccessToken } from '../../../api/index';
import axios from 'axios';

export const getTravelPartnersAPI = async (event_type) => {
  let response = await getAPI(
    config.quicklinkUrl + GET_TRAVEL_PARTNERS_URL + '?type=' + event_type
  );
  return response;
};

export const getBlockedTravelPartners = async (event_type) => {
  let response = await getAPI(
    config.quicklinkUrl + GET_TRAVEL_PARTNERS_BLOCK_LIST + `?type=${event_type}`
  );

  return response;
};

export const getQuickLinkReviewsAPI = async (event_type) => {
  let response = await getAPI(
    config.quicklinkUrl +
      GET_QUICKLINK_IMAGES_REVIEWS_URL +
      '?status=REVIEW_APPROVED&type=review&event_type=' +
      event_type
  );
  return response;
};

export const getQuickLinkImagesAPI = async (event_type) => {
  let response = await getAPI(
    config.quicklinkUrl +
      GET_QUICKLINK_IMAGES_REVIEWS_URL +
      '?status=IMAGE_APPROVED&type=image&event_type=' +
      event_type
  );
  return response;
};

export const getQuickLinkWalletAPI = async (
  user_id,
  event_id,
  type = 'general'
) => {
  if (type === 'event') {
    let response = await getAPI(
      config.quicklinkUrl +
        GET_QUICKLINK_WALLET_URL +
        '?added_by=' +
        user_id +
        '&event_id=' +
        event_id
    );
    return response;
  } else {
    let response = await getAPI(
      config.quicklinkUrl +
        GET_QUICKLINK_WALLET_URL +
        '?added_by=' +
        user_id +
        '&type=' +
        event_id
    );
    return response;
  }
};

export const uploadWalletsAPI = async (body) => {
  let response = await postAPI(
    config.quicklinkUrl + UPLOAD_QUICKLINK_WALLET_URL,
    body
  );
  return response;
};

export const getPolicyDocumentsAPI = async () => {
  let response = await getAPI(config.quicklinkUrl + GET_POLICY_DOCS_URL);
  return response;
};

export const addTravelPartnerAPI = async (travelPartnersData, type) => {
  let response = await postAPI(
    config.quicklinkUrl + ADD_NEW_TRAVEL_PARTNERS + '?type=' + type,
    travelPartnersData
  );
  return response;
};

export const editTravelPartnerAPI = async (travelPartnersData, type) => {
  let response = await putAPI(
    config.quicklinkUrl + EDIT_TRAVEL_PARTNERS + '?type=' + type,
    travelPartnersData
  );
  return response;
};

export const deleteTravelPartnerAPI = async (travelpartnerId) => {
  let response = await deleteAPI(
    config.quicklinkUrl +
      DELETE_TRAVEL_PARTNERS +
      '?travelpartner_id=' +
      travelpartnerId
  );
  return response;
};

// 1. Add Hotel Details
export const addHotelDetailsAPI = async (hotelData) => {
  let response = await postAPI(
    config.quicklinkUrl + ADD_HOTEL_DETAILS,
    hotelData
  );
  return response;
};

// 2. Edit Hotel Details
export const editHotelDetailsAPI = async (hotel_id, hotelData) => {
  let response = await putAPI(
    config.quicklinkUrl + EDIT_HOTEL_DETAILS + '/' + hotel_id,
    hotelData
  );
  return response;
};

// 3. Delete Hotel Details
export const deleteHotelDetailsAPI = async (hotelId) => {
  let response = await deleteAPI(
    config.quicklinkUrl + DELETE_HOTEL_DETAILS + '/' + hotelId
  );
  return response;
};

// 4. Get Hotel Details
export const getHotelListAPI = async (
  hotel_name,
  city,
  number_of_participants,
  rate,
  search,
  page = 1,
  per_page = 10
) => {
  try {
    const queryParams = new URLSearchParams();

    if (search) queryParams.append('search', search);
    if (hotel_name) queryParams.append('hotel_name', hotel_name);
    if (city) queryParams.append('city', city);
    if (number_of_participants) {
      queryParams.append('number_of_participants', number_of_participants);
    }
    if (rate) queryParams.append('rate', rate);
    
    // Add pagination parameters
    queryParams.append('page', page.toString());
    queryParams.append('per_page', per_page.toString());

    const url = `${
      config.quicklinkUrl
    }${GET_HOTEL_DETAILS}?${queryParams.toString()}`;

    const response = await getAPI(url);
    return response;
  } catch (error) {
    console.error('Error in Fetching Hotel Details:', error);
    throw error;
  }
};

// Separate download API function
export const downloadAPI = async (url) => {
  try {
    const access_token = getAccessToken();

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'x-access-token': access_token
      }
    });

    if (!response?.ok) {
      let errorMessage = `Failed to download file: ${response?.status}`;

      try {
        // Try to parse JSON error response
        const errorData = await response.json();
        if (errorData?.message) {
          errorMessage = errorData?.message;
        } else if (errorData?.error) {
          errorMessage = errorData?.error;
        }
      } catch (parseError) {
        // If JSON parsing fails, try to get text response
        try {
          const errorText = await response.text();
          if (errorText) {
            errorMessage = errorText;
          }
        } catch (textError) {
          // If both fail, use the default error message
          console.error('Failed to parse error response:', textError);
        }
      }
      throw new Error(errorMessage);
    }

    const blob = await response?.blob();
    const contentDisposition = response?.headers?.get('Content-Disposition');

    let filename = '';
    if (contentDisposition) {
      const filenameMatch = contentDisposition?.match(
        /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i
      );
      if (filenameMatch && filenameMatch[2]) {
        filename = filenameMatch[2];
      } else if (filenameMatch && filenameMatch[3]) {
        filename = filenameMatch[3];
      }
    }

    return {
      data: blob,
      filename: filename
    };
  } catch (error) {
    console.error('Download API Error:', error);
    throw error;
  }
};

// Download Review Report

export const downloadReviewReportAPI = async (event_id) => {
  try {
    const response = await downloadAPI(
      config.quicklinkUrl + `${DOWNLOAD_REVIEW_REPORT}?event_id=${event_id}`
    );
    return response;
  } catch (error) {
    console.error('Error in Downloading Review Report:', error);
    throw error;
  }
};

// Bulk Upload Hotel Details API
export const bulkUploadHotelDetailsAPI = async (file) => {
  try {
    const access_token = getAccessToken();
    const formData = new FormData();
    formData.append('file', file);
    
    // Make the request with proper headers for form-data
    const response = await axios?.post(
      config.quicklinkUrl + BULK_UPLOAD_HOTEL_DETAILS,
      formData,
      {
        headers: {
          'x-access-token': access_token,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    // Handle response similar to other API functions
    if (response?.data && response?.data?.error) {
      return { error: true, message: response?.data?.message || 'Upload failed' };
    }
    return { data: response?.data, error: false };
  } catch (error) {
    console.error('Error in Bulk Uploading Hotel Details:', error);
    if (error?.response && error?.response?.data && error?.response?.data?.message) {
      return { error: true, message: error?.response?.data?.message };
    }
    return { error: true, message: 'Something went wrong' };
  }
};

// Bulk Upload Menu Details API
export const bulkUploadMenuDetailsAPI = async (file, eventId, dateOfEvent) => {
  try {
    const access_token = getAccessToken();
    const formData = new FormData();
    formData.append('file', file);
    
    // Build query parameters
    const queryParams = new URLSearchParams();
    queryParams.append('event_id', eventId);
    if (dateOfEvent) {
      queryParams.append('date_of_event', dateOfEvent);
    }
    
    // Make the request with proper headers for form-data and query parameters
    const response = await axios?.post(
      `${config.quicklinkUrl}${UPLOAD_MENU_URL}?${queryParams.toString()}`,
      formData,
      {
        headers: {
          'x-access-token': access_token,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    // Handle response similar to other API functions
    if (response?.data && response?.data?.error) {
      return { error: true, message: response?.data?.message || 'Upload failed' };
    }
    return { data: response?.data, error: false };
  } catch (error) {
    console.error('Error in Bulk Uploading Menu Details:', error);
    if (error?.response && error?.response?.data && error?.response?.data?.message) {
      return { error: true, message: error?.response?.data?.message };
    }
    return { error: true, message: 'Something went wrong' };
  }
};

// Get Quizzes

export const getQuizzesAPI = async () => {
  let response = await getAPI(config.quicklinkUrl + GET_QUIZ);
  return response;
};

export const quotationCostBenchmarkingAPI = async (
  event_id,
  // session_name = 'Cost Benchmarking Solution'
) => {
  try {
    const response = await postAPI(
      config.quicklinkUrl + EXECUTE_COST_BENCHMARK + 
      '?event_id=' + event_id
      // '&session_name=' + encodeURIComponent(session_name)
    );
    const { session_id, status } = response?.data?.data?.data;    
    // Poll until status is completed
    if (status === 'in_progress') {
      return await pollForBenchmarkCompletion(event_id, session_id);
    }
    
    // If already completed, fetch the data
    return await getFinalBenchmarkDataAPI(event_id, session_id);
  } catch (error) {
    console.error('Error in Cost Benchmarking API:', error);
    throw error;
  }
};

export const quotationCostBenchmarkingRerunAPI = async (
  event_id,
  // session_name = 'Cost Benchmarking Solution'
) => {
  try {
    const response = await postAPI(
      config.quicklinkUrl + EXECUTE_COST_BENCHMARK + 
      '?event_id=' + event_id + 
      // '&session_name=' + encodeURIComponent(session_name) +
      '&run=run_mind'
    );
    const { session_id, status } = response?.data?.data?.data;    
    // Poll until status is completed
    if (status === 'in_progress') {
      return await pollForBenchmarkCompletion(event_id, session_id);
    }
    
    // If already completed, fetch the data
    return await getFinalBenchmarkDataAPI(event_id, session_id);
  } catch (error) {
    console.error('Error in Cost Benchmarking Re-Run API:', error);
    throw error;
  }
};

const pollForBenchmarkCompletion = async (event_id, session_id, maxAttempts = 500, interval = 5000) => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    await new Promise(resolve => setTimeout(resolve, interval));
    
    try {
      const response = await getAPI(
        config.quicklinkUrl + GET_COST_BENCHMARKING_DATA + 
        '?event_id=' + event_id + 
        '&session_id=' + session_id
      );
      
      const statusData = response?.data?.data;
      if (statusData.status === 'completed') {
        return statusData.response;
      } else if (statusData.status === 'failed' || statusData.status === 'error') {
        throw new Error('Benchmarking execution failed');
      }
    } catch (error) {
      if (attempt === maxAttempts - 1) {
        throw new Error('Polling timeout: Benchmarking took too long to complete');
      }
    }
  }
  
  throw new Error('Benchmarking execution timeout');
};

export const getFinalBenchmarkDataAPI = async (
  event_id,
  session_id
) => {
  try {
    const response = await getAPI(
      config.quicklinkUrl + GET_COST_BENCHMARKING_DATA + 
      '?event_id=' + event_id + 
      '&session_id=' + session_id
    );
    
    const statusData = response?.data?.data;    
    if (statusData.status === 'completed') {
      return statusData.response;
    } else if (statusData.status === 'in_progress') {
      return await pollForBenchmarkCompletion(event_id, session_id);
    } else {
      throw new Error('Invalid benchmark status');
    }
  } catch (error) {
    console.error('Error in Getting Final Benchmark Data:', error);
    throw error;
  }
};

export const getBenchmarkDataAPI = async (page = 1, per_page = 5, search = '') => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('per_page', per_page.toString());
    if (search && search.trim()) queryParams.append('search', search.trim());

    const url = `${config.quicklinkUrl}${GET_BENCHMARK_DATA}?${queryParams.toString()}`;
    const response = await getAPI(url);
    return response;
  } catch (error) {
    console.error('Error fetching benchmark data:', error);
    throw error;
  }
};

// Get dropdown data for head/sub_head/item
// Note: API is paginated; for dropdowns we need all pages to build full options.
export const getDropdownDataAPI = async (type, head_id = null, sub_head_id = null, options = {}) => {
  const { paginateAll = true, per_page = 50 } = options;
  try {
    const baseParams = new URLSearchParams();
    baseParams.append('type', type);
    if (head_id) baseParams.append('head_id', head_id);
    if (sub_head_id) baseParams.append('sub_head_id', sub_head_id);

    const buildUrl = (page) => {
      const params = new URLSearchParams(baseParams.toString());
      params.append('page', page.toString());
      params.append('per_page', per_page.toString());
      return `${config.quicklinkUrl}${GET_BENCHMARK_DATA}?${params.toString()}`;
    };

    const firstResponse = await getAPI(buildUrl(1));
    if (!paginateAll) return firstResponse;

    const firstPayload = firstResponse?.data?.data || {};
    const totalPages = Number(firstPayload?.pagination?.pages || 1);
    const combinedData = Array.isArray(firstPayload?.data) ? [...firstPayload.data] : [];

    if (totalPages > 1) {
      for (let page = 2; page <= totalPages; page += 1) {
        const pageResponse = await getAPI(buildUrl(page));
        const pagePayload = pageResponse?.data?.data || {};
        if (Array.isArray(pagePayload?.data)) {
          combinedData.push(...pagePayload.data);
        }
      }
    }

    const mergedResponse = {
      ...firstResponse,
      data: {
        ...firstResponse.data,
        data: {
          ...firstPayload,
          data: combinedData,
          pagination: {
            ...firstPayload.pagination,
            page: 1,
            pages: 1,
            total: combinedData.length,
          },
        },
      },
    };

    return mergedResponse;
  } catch (error) {
    console.error('Error fetching dropdown data:', error);
    throw error;
  }
};

// Quotation Requests
export const getQuotationRequestsAPI = async (page = 1, per_page = 10, search = '') => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
  
  if (search) {
    queryParams.append('search', search);
  }
  
  const url = `${config.quicklinkUrl}${GET_QUOTATION_REQUESTS}?${queryParams.toString()}`;
  let response = await getAPI(url);
  return response;
};

export const approveQuotationRequestAPI = async (request_id, reason) => {
  if (!request_id) {
    return { error: true, message: "Request ID is required" };
  }

  if (!reason) {
    return { error: true, message: "Reason is required" };
  }

  const payload = {
    request_id,
    reason
  };

  const url = `${config.quicklinkUrl}${APPROVE_QUOTATION_REQUEST}`;
  let response = await putAPI(url, payload);
  return response;
};

export const editBenchmarkDataAPI = async (benchmarkId, benchmarkData) => {
  try {
    const url = `${config.quicklinkUrl}${EDIT_BENCHMARK_DATA}/${benchmarkId}`;
    const response = await putAPI(url, benchmarkData);
    return response;
  } catch (error) {
    console.error('Error updating benchmark data:', error);
    throw error;
  }
};

export const editBenchmarkData = async (benchmarkData) => {
  try {
    const url = `${config.quicklinkUrl}${EDIT_BENCHMARK}`;
    const response = await postAPI(url, benchmarkData);
    return response;
  } catch (error) {
    console.error('Error updating benchmark data:', error);
    throw error;
  }
};

export const updateBenchmarkFromInvoiceAPI = async (payload) => {
  try {
    const url = `${config.quicklinkUrl}${UPDATE_BENCHMARK_FROM_INVOICE}`;
    const response = await postAPI(url, payload);
    return response;
  } catch (error) {
    console.error('Error updating benchmark from invoice:', error);
    throw error;
  }
};

// Get Survey Statistics Details:

export const getSurveyStatisticsAPI = async (page = 1, per_page = 10, response_type = 'statistics') => {
  try {
    const queryParams = new URLSearchParams();
    
    // Set response type to statistics
    queryParams.append('response_type', response_type);
    
    // Add pagination parameters
    queryParams.append('page', page.toString());
    queryParams.append('per_page', per_page.toString());

    const url = `${config.quicklinkUrl}${GET_SURVEY_FORM_RESPONSES}?${queryParams.toString()}`;
    
    const response = await getAPI(url);
    return response;
  } catch (error) {
    console.error('Error in Fetching Survey Statistics:', error);
    throw error;
  }
};

// Archived Folder for images

export const getArchivedFolderImagesAPI = async (event_type, event_status = null) => {
  let url = config.quicklinkUrl +
    GET_QUICKLINK_IMAGES_REVIEWS_URL +
    '?status=IMAGE_APPROVED&type=image&event_type=' +
    event_type;
  
  // Add event_status parameter if provided
  if (event_status) {
    url += '&event_status=' + event_status;
  }
  
  let response = await getAPI(url);
  return response;
};

// Event Session APIs

// Add Event Session API
export const addEventSessionAPI = async (eventId, sessionData) => {
  try {
    const response = await postAPI(
      config.quicklinkUrl + ADD_EVENT_SESSION + `?event_id=${eventId}`,
      sessionData
    );
    return response;
  } catch (error) {
    console.error('Error in Adding Event Session:', error);
    throw error;
  }
};

// Edit Event Session API
export const editEventSessionAPI = async (eventId, sessionData) => {
  try {
    const response = await putAPI(
      config.quicklinkUrl + EDIT_EVENT_SESSION + `?event_id=${eventId}`,
      sessionData
    );
    return response;
  } catch (error) {
    console.error('Error in Editing Event Session:', error);
    throw error;
  }
};

// Get Event Sessions API
export const getEventSessionsAPI = async (eventId) => {
  try {
    const response = await getAPI(
      config.quicklinkUrl + GET_EVENT_SESSIONS + `?event_id=${eventId}`
    );
    return response;
  } catch (error) {
    console.error('Error in Fetching Event Sessions:', error);
    throw error;
  }
};

// Delete Event Session API
export const deleteEventSessionAPI = async (deleteData) => {
  try {
    const response = await putAPI(
      config.quicklinkUrl + DELETE_EVENT_SESSION,
      deleteData
    );
    return response;
  } catch (error) {
    console.error('Error in Deleting Event Session:', error);
    throw error;
  }
};

// Get Food Menu

export const getFoodMenuAPI = async (eventId, dateOfEvent) => {
  try {
    const response = await getAPI(
      config.quicklinkUrl + GET_FOOD_MENU_URL + `?event_id=${eventId}&date_of_event=${dateOfEvent}`
    );
    return response;
  } catch (error) {
    console.error('Error in Fetching Food Menu:', error);
    throw error;
  }
};

// Update Food Menu Status

export const updateFoodMenuStatusAPI = async (eventId, dateOfEvent, toShow) => {
  try {
    const payload = {
      to_show: toShow,
      event_id: eventId,
      date_of_event: dateOfEvent
    };
    const response = await putAPI(
      config.quicklinkUrl + UPDATE_FOOD_MENU_STATUS,
      payload
    );
    return response;
  } catch (error) {
    console.error('Error in Updating Food Menu Status:', error);
    throw error;
  }
};

// Delete Wallet API
export const deleteWalletAPI = async (wallet_id) => {
  let response = await deleteAPI(
    config.quicklinkUrl + DELETE_WALLET + `/${wallet_id}`
  );
  return response;
};

// Download Survey Report API
export const downloadSurveyReportAPI = async (survey_id) => {
  try {
    const response = await downloadAPI(
      config.quicklinkUrl + `${DOWNLOAD_SURVEY_REPORT}?survey_id=${survey_id}`
    );
    return response;
  } catch (error) {
    console.error('Error in Downloading Survey Report:', error);
    throw error;
  }
};

// Get Deleted Events API
export const getDeletedEventsAPI = async (type = 'mice', page = 1, per_page = 10) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('type', type);
    queryParams.append('page', page.toString());
    queryParams.append('per_page', per_page.toString());

    const url = `${config.quicklinkUrl}${GET_DELETED_EVENTS}?${queryParams.toString()}`;
    const response = await getAPI(url);
    return response;
  } catch (error) {
    console.error('Error in Fetching Deleted Events:', error);
    throw error;
  }
};

// Upload Quotation API
export const uploadQuotationAPI = async (quotationData, save_type = 'submit') => {
  try {
    const response = await postAPI(
      config.quicklinkUrl + UPLOAD_QUOTATION + `?save_type=${save_type}`,
      quotationData
    );
    return response;
  } catch (error) {
    console.error('Error in Uploading Quotation:', error);
    throw error;
  }
};

// List Quotations API
export const listQuotationsAPI = async (event_id, travel_partner_id) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('event_id', event_id);
    if (travel_partner_id) {
      queryParams.append('travel_partner_id', travel_partner_id);
    }

    const url = `${config.quicklinkUrl}${LIST_QUOTATIONS}?${queryParams.toString()}`;
    const response = await getAPI(url);
    return response;
  } catch (error) {
    console.error('Error in Fetching Quotations:', error);
    throw error;
  }
};

// Request Edit Quotation API
export const requestEditQuotationAPI = async (quotationData) => {
  try {
    const response = await postAPI(
      config.quicklinkUrl + REQUEST_EDIT_QUOTATION,
      quotationData
    );
    return response;
  } catch (error) {
    console.error('Error in Requesting Edit Quotation:', error);
    throw error;
  }
};

// Edit Quotation API
export const editQuotationAPI = async (quotationData, save_type = 'submit') => {
  try {
    const response = await putAPI(
      config.quicklinkUrl + EDIT_QUOTATION + `?save_type=${save_type}`,
      quotationData
    );
    return response;
  } catch (error) {
    console.error('Error in Editing Quotation:', error);
    throw error;
  }
};

// Delete Quotation API
export const deleteQuotationAPI = async (quotation_id) => {
  try {
    const response = await deleteAPI(
      config.quicklinkUrl + DELETE_QUOTATION + `/${quotation_id}`
    );
    return response;
  } catch (error) {
    console.error('Error in Deleting Quotation:', error);
    throw error;
  }
};

// Quotation Analysis API
export const quotationAnalysisAPI = async (event_id) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('event_id', event_id);

    const url = `${config.quicklinkUrl}${QUOTATION_ANALYSIS}?${queryParams.toString()}`;
    const response = await getAPI(url);
    
    if (response.error) {
      throw new Error(response.message || 'Failed to fetch quotation analysis');
    }
    
    return response;
  } catch (error) {
    console.error('Error in Quotation Analysis API:', error);
    throw error;
  }
};

// Download Quotation Analysis PDF
export const downloadQuotationAnalysisPDF = async (event_id) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('event_id', event_id);
    queryParams.append('pdf_download', 'true');

    const response = await downloadAPI(
      `${config.quicklinkUrl}${QUOTATION_ANALYSIS}?${queryParams.toString()}`
    );
    return response;
  } catch (error) {
    console.error('Error in Downloading Quotation Analysis PDF:', error);
    throw error;
  }
};
